import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        chatId: Number,
    };

    acceptCase(event) {
        if (event) {
            event.preventDefault();
        }

        showPreloader();

        document.querySelector('#accept-reject-case-buttons')?.classList.add('d-none');
        document.querySelector('#message-bar .message-box')?.classList.remove('d-none');
        window.calculateMessagesConversationChatHeight();

        hidePreloader();
    }
}
